<script lang="ts">
	import { getLanguageCode } from '$lib/i18n/language';
	import { formatPrice } from '$lib/utils/formatPrice';
	import * as m from '$paraglide/messages';

	interface Props {
		amount?: number;
		currency?: string;
		redirectUrl: string;
		index: number;
		onHandleRedirection?: (roomPosition: number) => void;
	}

	const {
		amount = 0,
		currency = 'EUR',
		redirectUrl,
		index,
		onHandleRedirection,
	}: Props = $props();

	function handleRedirection(event: Event, redirectUrl: string) {
		event.stopPropagation();
		window.open(redirectUrl, '_blank', 'noopener');
		onHandleRedirection?.(index + 1);
	}
</script>

<div
	role="button"
	tabindex={index}
	onkeypress={(event) => {
		if (event.key === 'Enter') {
			handleRedirection(event, redirectUrl);
		}
	}}
	class="flex p-2 bg-neutral-weak rd-1 flex-col justify-start items-start gap-2 cursor-pointer"
	onclick={(event) => {
		handleRedirection(event, redirectUrl);
	}}
>
	<div class="self-stretch text-sm text-coloredneutral-strongest clamp-lines-2 min-w-max">
		{m.poi_datasheet__availability_offer({ count: index + 1 })}
	</div>
	<div class="self-stretch text-sm text-bold text-origin">
		{formatPrice({ amount, currency, language: getLanguageCode() })}
	</div>
</div>
